import React, { KeyboardEvent } from 'react';
import { getObjectAttachment, getObjectClaimUserInfo, getObjectRequester } from './localStorage/localStorage';
import { isNullOrEmpty } from './formValidation';
import appConfig from '../constants/config';


export const setdefzeroval = (val: string) => (val == '' ? 0 : parseFloat(val));

export const logDecimalValue = (event: KeyboardEvent<HTMLInputElement>): boolean => {
    const target = event.currentTarget;

    if (target.classList.contains("integer-control")) {
        if (!/^[0-9]$/.test(event.key) && event.key !== "Backspace") {
            event.preventDefault();
            return false;
        }

        return true;
    } else if (target.classList.contains("decimal-control")) {
        // Allow digits, a single period, and Backspace
        if (!/^[0-9.]$/.test(event.key) && event.key !== "Backspace") {
            event.preventDefault();
            return false;
        }

        // Prevent more than one period
        if (event.key === "." && target.value.includes(".")) {
            event.preventDefault();
            return false;
        }

        return true;
    }

    return false;
};


export const decimalRemove = () => {
    const decimal_check = ""; // Define decimal_check according to your requirements

    // Check if the retrieved JSON data is not empty or null before parsing
    const objRequestor = getObjectRequester();
    const objClaimUserInfo = getObjectClaimUserInfo();

    //Control to check which page that the user is accessing
    //The reason to used the right information to supply for decimal removing
    const page_accessing = window.location.href;

    //ClaimItems page
    if (page_accessing.indexOf("ClaimItems") > 0 || page_accessing.indexOf("Form") > 0) {
        if (decimal_check.includes(objRequestor?.country_code)) {
            return 2;
        } else {
            return 2;
        }
    }

    //ExpReport Page
    else if (page_accessing.indexOf("ExpReport") > 0) {

        //ObjClaimUserInfo Checking
        if (!isNullOrEmpty(objClaimUserInfo)) {
            if (decimal_check.includes(objClaimUserInfo?.country_code)) {
                return 0;
            } else {
                return 2;
            }
        }

        //ObjRequestor Checking
        else if (!isNullOrEmpty(objRequestor)) {
            if (decimal_check.includes(objRequestor?.country_code)) {
                return 0;
            } else {
                return 2;
            }
        }
    } else if (page_accessing.indexOf("QuickAdd") > 0) {
        if (decimal_check.includes(objRequestor?.country_code)) {
            return 0;
        } else {
            return 2;
        }
    }

    return 0; // Default return value if none of the conditions are met
};




export const checkInputDecimal = (i: number, inputValues: { [key: string]: any | undefined }) => {
    const decimal_check = ""; // Define decimal_check according to your requirements
    const currency_decimal_check = appConfig.CurrencyDecimal || "";

    // Check if the retrieved JSON data is not empty or null before parsing
    const objRequestor = getObjectRequester();
    const objClaimUserInfo = getObjectClaimUserInfo();
    const objAttachment = getObjectAttachment();

    //Control to check which page that the user is accessing
    //The reason to used the right information to supply for decimal removing
    const page_accessing = window.location.href;
    let ddlCurrencyValue = (objAttachment && !isNullOrEmpty(objAttachment.foreign_currency )) ? objAttachment.foreign_currency : inputValues[`ddlCurrency${i}`];
 
    //ClaimItems page
    if (page_accessing.indexOf("ClaimItems") > 0) {

        if (currency_decimal_check.includes(ddlCurrencyValue)) {
            setControlAttributes(i, "1", "integer_control");
            return 0;
        } else {
            setControlAttributes(i, ".01", "decimal_control");
            return 2;
        }
    }

    //ExpReport Page
    else if (page_accessing.indexOf("ExpReport") > 0) {

        //ObjClaimUserInfo Checking
        if (!isNullOrEmpty(objClaimUserInfo)) {

            if (currency_decimal_check.includes(ddlCurrencyValue)) {
                setControlAttributes(i, "1", "integer_control");
                return 0;
            } else {
                setControlAttributes(i, ".01", "decimal_control");
                return 2;
            }
        }

        //ObjRequestor Checking
        else if (!isNullOrEmpty(objRequestor)) {

            if (currency_decimal_check.includes(ddlCurrencyValue)) {
                setControlAttributes(i, "1", "integer_control");
                return 0;
            } else {
                setControlAttributes(i, ".01", "decimal_control");
                return 2;
            }
        }
    } else if (page_accessing.indexOf("QuickAdd") > 0) {

        if (currency_decimal_check.includes(ddlCurrencyValue)) {
            setControlAttributes(i, "1", "integer_control");
            return 0;
        } else {
            setControlAttributes(i, ".01", "decimal_control");
            return 2;
        }
    }

    return 0; // Default return value if none of the conditions are met
};


export function smartRound(amount: number, digit: number): number {
    const str = amount.toString();
    const decimalIndex = str.indexOf('.');
    const currentDecimalPlaces = decimalIndex >= 0 ? str.length - decimalIndex - 1 : 0;
    
    if (currentDecimalPlaces > digit) {
      return Number(amount.toFixed(digit));
    }

    return amount;
}


const setControlAttributes = (i: number, step: string, controlClass: string) => {
    const elements = ["txtClaimAmount", "txtcoderate1_", "txtcoderate2_", "txtcoderate3_", "txtcoderate4_"];

    elements.forEach((element) => {
        const inputElement = document.getElementById(element + i) as HTMLInputElement;
        if (inputElement) {
            inputElement.setAttribute("step", step);
            inputElement.classList.add(controlClass);
            inputElement.classList.remove("integer_control", "decimal_control");
        }
    });
};



export const is45RoundingApplies = (decimalRounding45RuleCheck: string) => {
    const countryList = decimalRounding45RuleCheck.split(",");
    const objTempRequestorDec = getObjectRequester();

    if (objTempRequestorDec) {
        return countryList.includes(objTempRequestorDec.country_code);
    } else {
        return false;
    }
}



export const convertToDate = (dateString: string): Date => {
    const day = parseInt(dateString.substring(0, dateString.indexOf("/")), 10);
    const month = parseInt(dateString.substring(dateString.indexOf("/") + 1, dateString.lastIndexOf("/")), 10) - 1;
    const year = parseInt(dateString.substring(dateString.lastIndexOf("/") + 1), 10);
    const _date = new Date(year, month, day);
    return _date;
};




export const CalConvertAmt = (i: string, inputValues: { [key: string]: any | undefined }, input_decimal: number, handleInputChange: (id: string, value?: any) => void): any => {
    let exchangeRate = 0;
    let cat_id_n = i.substring(-1) == "0" ? 10 : parseInt(i.substring(-1));
    let input_amount = parseFloat(inputValues[`txtClaimAmount${i}`]);
    let number_of_decimal = decimalRemove();

    exchangeRate = parseFloat(input_amount.toFixed(input_decimal)) * parseFloat(inputValues[`txtExchangeRate${i}`]);



    if (number_of_decimal == 0) {
        exchangeRate = Math.floor(exchangeRate);
    }

    handleInputChange(`txtExchangeAmount${i}`, exchangeRate.toFixed(number_of_decimal))

};


// Manipulate options array to set the value as the label
export const getAutoCompleteOptionValueAsLabel = (selectedValue: string, objDDL: any) => {

    console.log("selectedValue :" + selectedValue);
    if (selectedValue) {
        const selected = objDDL.filter(
            (option: any) => option.value === selectedValue
        );
        if (selected.length > 0) {
            return selected[0].value;
        }
        else {
            return "";
        }
    }
};


export const formatTpiNo = (value: string): string => {
    // Remove all non-numeric characters
    let formattedValue = value.replace(/\D/g, '');

    // Remove all existing dashes
    formattedValue = formattedValue.replace(/-/g, '');

    // Add dashes every 3 characters, but stop after 3 dashes
    formattedValue = formattedValue.replace(/([0-9]{3})(?=[0-9])/g, (match, p1, offset) => {
        const numberOfDashes = Math.floor(offset / 3);
        return numberOfDashes < 3 ? p1 + '-' : p1;
    });

    // Split the string into parts based on dashes
    let parts = formattedValue.split('-');

    // Limit the last part to 5 characters if there are more than 3 parts
    if (parts.length > 3) {
        parts = parts.slice(0, 3).concat(parts.slice(3).join('').slice(0, 5));
    } else if (parts.length === 3) {
        parts[2] = parts[2].slice(0, 5);
    }

    // Join the parts back together with dashes
    formattedValue = parts.join('-');

    // Remove any trailing dash if it exists
    return formattedValue.replace(/-$/, '');
};



export function titleCase(string: string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

export function isNumeric(input: string): boolean {
    const numericPattern = /^-?\d+(\.\d+)?$/; // Allows integers and floating numbers
    return numericPattern.test(input);
}


export function onKeyInputOnlyNumber(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> , num = 20 , dropLeadingZero = false): void {
    // Keep only numbers
    let value = e.target.value.replace(/[^0-9]/g, "");

    // If first character is '0' and there’s another digit, drop the leading 0
    if (dropLeadingZero && value.length > 1 && value.startsWith("0")) {
        value = value.replace(/^0+/, "");
    }

    // Enforce max 9 characters
    if (value.length > num) {
        value = value.slice(0, num);
    }

    // Update the input value
    e.target.value = value;
}


export function checkEmail(emailAddress: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(emailAddress);
}
